import axios from 'axios';

// React does not have Vue's boot/globalProperties pattern, so export the
// shared axios instances and import them where needed.
// const api = axios.create({
//   baseURL: 'https://4k4cm4x9o8.execute-api.us-east-2.amazonaws.com/dev',
// });

const api = axios.create({
  baseURL: 'https://44h9ldfzeh.execute-api.us-east-2.amazonaws.com/staging',
  headers: {
    'x-api-key': 'BtQXWcFUbJab94fweYZAiI7FCrD4zkO7',
  },
});

export { axios, api };
export default api;
